import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import routesReducer from './slices/routesSlice';
import eventsReducer from './slices/eventsSlice';
import checklistsReducer from './slices/checklistsSlice';
import collaborationReducer from './slices/collaborationSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    routes: routesReducer,
    events: eventsReducer,
    checklists: checklistsReducer,
    collaboration: collaborationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 